"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var base_1 = require("utils/selectors/base");
var single_1 = require("utils/selectors/single");
var DataCorrectButtons_1 = __importDefault(require("./DataCorrectButtons"));
var SetupHeader_1 = __importDefault(require("./SetupHeader"));
var SetupSteps_1 = __importDefault(require("./SetupSteps"));
var Setup = function () {
    var _a, _b;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'rech_contacts', where: ['companyId', '==', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id] },
        {
            collection: 'xero_accounts',
            where: [['companyId', '==', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id], ['Class', 'in', ['REVENUE', 'ASSET', 'EXPENSE']]],
        }
    ]; });
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return []; });
    var isAdvancedMode = (0, react_redux_1.useSelector)(base_1.selectAdvancedMode);
    var setupSeps = (rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.isAdvancedFlow)
        ? interfaces_1.RECHARGES_SETUP_STEPS_ADVANCED
        : interfaces_1.RECHARGES_SETUP_STEPS;
    var totalSteps = setupSeps.length;
    var stepsDone = (_b = (_a = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargeSetupSteps) === null || _a === void 0 ? void 0 : _a.filter(function (step) { return setupSeps.includes(step); }).length) !== null && _b !== void 0 ? _b : 0;
    if (!(0, react_redux_firebase_1.isLoaded)(rechargerCompany)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, __assign({ container: true, width: 640, mt: 3, pb: 4, mx: "auto" }, { children: [profile.isAdmin && isAdvancedMode && (0, jsx_runtime_1.jsx)(DataCorrectButtons_1.default, {}), (0, jsx_runtime_1.jsx)(SetupHeader_1.default, { totalSteps: totalSteps, stepsDone: stepsDone }), (0, jsx_runtime_1.jsx)(SetupSteps_1.default, { steps: setupSeps })] })) })));
};
exports.default = Setup;
